"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useBasepath;
function useBasepath() {
  return process.env.REACT_STATIC_DISABLE_ROUTE_PREFIXING === 'true' ? '' : process.env.REACT_STATIC_BASE_PATH;
}